import React from 'react';
import Icon from '../Icon';

const LandingCTA = ({ onCTA }) => (
  <section className="landing-cta" id="check">
    <div className="container">
      <div className="landing-cta-card">
        <div className="landing-cta-left">
          <span className="eyebrow eyebrow-coral">
            <Icon name="sparkle" size={12} stroke={2.5}/> Free eligibility check
          </span>
          <h2>
            Find out what you could earn
          </h2>
          <p className="lede">
            A few quick questions about your situation. We'll tell you which programs you may qualify
            for and what you could earn — and then walk you through every step of the application.
          </p>
          <ul className="landing-cta-perks">
            <li><span className="check"><Icon name="check-bold" size={11}/></span>
              Personalized to your state &amp; situation</li>
            <li><span className="check"><Icon name="check-bold" size={11}/></span>
              No social security number, no credit check</li>
            <li><span className="check"><Icon name="check-bold" size={11}/></span>
              We handle the paperwork — start to finish</li>
          </ul>
          <div className="actions">
            <button className="btn btn-primary btn-md" onClick={onCTA}>
              Check Your Eligibility
              <Icon name="arrow-right" size={16} stroke={2.4} className="arrow"/>
            </button>
            <span className="reassure">
              <Icon name="lock" size={13} stroke={2.2}/> 100% free &amp; confidential
            </span>
          </div>
        </div>

        <div className="landing-cta-right">
          <div className="inner">
            <div className="est-eyebrow">Average approved family</div>
            <div className="est-amount">
              <span data-countup="true" data-count="$3,240">$3,240</span><span className="small"> / mo</span>
            </div>
            <div className="est-label">≈ $38,880 per year, paid by your state's program</div>
            <div className="breakdown">
              <div className="br-row"><span className="lbl">Hours / week (typical)</span><span className="val">28 hrs</span></div>
              <div className="br-row"><span className="lbl">Hourly rate (CA example)</span><span className="val">$18.20</span></div>
              <div className="br-row"><span className="lbl">Approval rate</span><span className="val">94%</span></div>
              <div className="br-row"><span className="lbl">Median time to first check</span><span className="val">14 days</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default LandingCTA;
